import { filtersHelper } from '@/utils';
import { companyModel } from '@/models/api/company.model';

export const departmentModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    description: data.description,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    companies: (data.companies ?? []).map(item => (companyModel(item))),
});